// Utilitaires de gestion des devises
// Taux de change basés sur EUR (1 EUR = taux de base)

// Taux de change par rapport à EUR (1 EUR = X devise)
const EXCHANGE_RATES = {
  EUR: 1,           // Euro (base)
  FCFA: 655,        // Franc CFA
  USD: 1.10,        // Dollar US (approximatif)
  GBP: 0.85,        // Livre Sterling
  NGN: 1600,        // Naira Nigérian
  XOF: 655,         // Franc CFA Ouest-Africain (même taux que FCFA)
  XAF: 655,         // Franc CFA Centre-Africain (même taux que FCFA)
  GHS: 13.5,        // Cedi Ghanéen
  ZAR: 20.5,        // Rand Sud-Africain
  KES: 140,         // Shilling Kenyan
  EGP: 50,          // Livre Égyptienne
  MAD: 11,          // Dirham Marocain
  TND: 3.3,         // Dinar Tunisien
  DZD: 150,         // Dinar Algérien
};

// Informations sur les devises
export const CURRENCIES = [
  { code: 'FCFA', symbol: 'FCFA', name: 'Franc CFA', flag: '🇨🇫' },
  { code: 'EUR', symbol: '€', name: 'Euro', flag: '🇪🇺' },
  { code: 'USD', symbol: '$', name: 'Dollar US', flag: '🇺🇸' },
  { code: 'GBP', symbol: '£', name: 'Livre Sterling', flag: '🇬🇧' },
  { code: 'NGN', symbol: '₦', name: 'Naira', flag: '🇳🇬' },
  { code: 'XOF', symbol: 'CFA', name: 'Franc CFA Ouest', flag: '🌍' },
  { code: 'XAF', symbol: 'FCFA', name: 'Franc CFA Centre', flag: '🌍' },
  { code: 'GHS', symbol: '₵', name: 'Cedi', flag: '🇬🇭' },
  { code: 'ZAR', symbol: 'R', name: 'Rand', flag: '🇿🇦' },
  { code: 'KES', symbol: 'KSh', name: 'Shilling', flag: '🇰🇪' },
  { code: 'EGP', symbol: 'E£', name: 'Livre Égyptienne', flag: '🇪🇬' },
  { code: 'MAD', symbol: 'DH', name: 'Dirham', flag: '🇲🇦' },
  { code: 'TND', symbol: 'DT', name: 'Dinar Tunisien', flag: '🇹🇳' },
  { code: 'DZD', symbol: 'DA', name: 'Dinar Algérien', flag: '🇩🇿' },
];

// Obtenir la devise sélectionnée depuis localStorage
export const getSelectedCurrency = () => {
  const saved = localStorage.getItem('selectedCurrency');
  return saved || 'FCFA'; // Par défaut FCFA
};

// Sauvegarder la devise sélectionnée
export const setSelectedCurrency = (currencyCode) => {
  localStorage.setItem('selectedCurrency', currencyCode);
};

// Obtenir les informations d'une devise
export const getCurrencyInfo = (currencyCode) => {
  return CURRENCIES.find(c => c.code === currencyCode) || CURRENCIES[0];
};

// Convertir un montant d'une devise vers EUR (pour total multi-devises)
export const convertToEUR = (amount, sourceCurrency) => {
  if (amount == null || isNaN(parseFloat(amount))) return 0;
  const a = parseFloat(amount);
  const rate = EXCHANGE_RATES[sourceCurrency];
  if (!rate) return a;
  return a / rate;
};

// Convertir un montant depuis FCFA vers une devise cible
export const convertFromFCFA = (amount, targetCurrency) => {
  if (!amount || isNaN(amount)) return 0;
  
  // Si la devise cible est FCFA, pas de conversion
  if (targetCurrency === 'FCFA' || targetCurrency === 'XOF' || targetCurrency === 'XAF') {
    return amount;
  }
  
  // Convertir FCFA -> EUR d'abord
  const amountInEUR = amount / EXCHANGE_RATES.FCFA;
  
  // Puis convertir EUR -> devise cible
  const rate = EXCHANGE_RATES[targetCurrency];
  if (!rate) return amount; // Si la devise n'existe pas, retourner le montant original
  
  return amountInEUR * rate;
};

// Convertir un montant depuis une devise source vers FCFA
export const convertToFCFA = (amount, sourceCurrency) => {
  if (!amount || isNaN(amount)) return 0;
  
  // Si la devise source est FCFA, pas de conversion
  if (sourceCurrency === 'FCFA' || sourceCurrency === 'XOF' || sourceCurrency === 'XAF') {
    return amount;
  }
  
  // Convertir devise source -> EUR
  const rate = EXCHANGE_RATES[sourceCurrency];
  if (!rate) return amount; // Si la devise n'existe pas, retourner le montant original
  
  const amountInEUR = amount / rate;
  
  // Puis convertir EUR -> FCFA
  return amountInEUR * EXCHANGE_RATES.FCFA;
};

// Formater un montant avec la devise
export const formatCurrency = (amount, currencyCode) => {
  const currency = getCurrencyInfo(currencyCode);
  const convertedAmount = convertFromFCFA(amount, currencyCode);
  
  // Formater selon la devise
  if (currencyCode === 'FCFA' || currencyCode === 'XOF' || currencyCode === 'XAF') {
    return {
      amount: convertedAmount.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
      symbol: currency.symbol,
      full: `${convertedAmount.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ${currency.symbol}`
    };
  } else {
    return {
      amount: convertedAmount.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      symbol: currency.symbol,
      full: `${currency.symbol}${convertedAmount.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    };
  }
};




























